import r from "react";
import i from "prop-types";
function m(t) {
  const s = [], u = {}, c = /{[a-zA-Z0-9_-]+}/g;
  let e = c.exec(t.template), a = 0;
  for (; e != null; ) {
    s.push(t.template.substr(a, e.index - a));
    const n = e[0].replace("{", "").replace("}", "");
    u[n] = (u[n] || 0) + 1;
    const o = `${n}-${u[n]}`;
    let l = t.values[n];
    l === void 0 ? [l] = e : r.isValidElement(l) && (l = r.cloneElement(l, { key: o })), s.push(l), a = e[0].length + e.index, e = c.exec(t.template);
  }
  return a < t.template.length && s.push(t.template.substr(a)), /* @__PURE__ */ r.createElement(r.Fragment, null, s);
}
m.propTypes = {
  /** The template string that will be rendered.  Values are wrapped in { and }, and must match the regex /[a-zA-Z0-9\_-]+/ */
  template: i.string.isRequired,
  /** Mapping of template key to the thing that will be inserted.  Can be omitted, and is treated like {} if so. */
  // eslint-disable-next-line react/forbid-prop-types
  values: i.object
};
m.defaultProps = {
  values: {}
};
export {
  m as I
};
